import { useState } from 'react';

const testimonials = [
  {
    quote:
      'Fletcher & Cooley handled our full restaurant build-out from permitting through final inspection. They coordinated every trade, kept us on schedule, and the health department passed us on the first visit. Couldn\'t ask for more.',
    name: 'Marcus T.',
    role: 'Restaurant Owner, McDonough, GA',
    stars: 5,
  },
  {
    quote:
      'We\'ve used Fletcher & Cooley for three tenant improvement projects across our Henry County properties. Every single one came in on time and within budget. Their communication is exceptional — I always know exactly where things stand.',
    name: 'Sandra R.',
    role: 'Commercial Property Manager, Stockbridge, GA',
    stars: 5,
  },
  {
    quote:
      'As a franchise operator, I need a contractor who understands brand standards and corporate requirements. Fletcher & Cooley delivered our build-out exactly to spec. They\'re the only contractor I call for new locations.',
    name: 'David K.',
    role: 'Franchise Operator, Hampton, GA',
    stars: 5,
  },
  {
    quote:
      'Our medical office build-out required precision — specific compliance requirements, safety systems, and cleanroom standards. Fletcher & Cooley handled every detail professionally. The space was ready ahead of schedule.',
    name: 'Dr. Patricia M.',
    role: 'Medical Practice Owner, Locust Grove, GA',
    stars: 5,
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-amber-600" />
            <span className="text-amber-700 text-xs font-semibold tracking-[0.2em] uppercase">
              Client Testimonials
            </span>
            <div className="w-8 h-px bg-amber-600" />
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-stone-900 leading-tight"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            What Our Clients Say
          </h2>
        </div>

        {/* Active testimonial */}
        <div className="max-w-3xl mx-auto mb-10">
          <div className="bg-white rounded-2xl p-10 border border-stone-100">
            {/* Stars */}
            <div className="flex gap-1 mb-6">
              {Array.from({ length: testimonials[active].stars }).map((_, i) => (
                <span key={i} className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-star-fill text-amber-500 text-base" />
                </span>
              ))}
            </div>
            <blockquote
              className="text-stone-700 text-lg leading-relaxed italic mb-8"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              &ldquo;{testimonials[active].quote}&rdquo;
            </blockquote>
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
                <i className="ri-user-line text-amber-700 text-lg" />
              </div>
              <div>
                <p className="font-bold text-stone-900 text-sm">{testimonials[active].name}</p>
                <p className="text-stone-500 text-xs">{testimonials[active].role}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-3 mb-12">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
                i === active ? 'bg-amber-700 w-6' : 'bg-stone-300'
              }`}
              aria-label={`Testimonial ${i + 1}`}
            />
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="#contact"
            className="whitespace-nowrap inline-flex items-center gap-2 bg-amber-700 hover:bg-amber-800 text-white font-semibold text-base px-10 py-4 rounded-full transition-all duration-300 cursor-pointer"
          >
            Schedule Your Consultation
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-base" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
